// Catálogo de plataformas integrables.
// `category` agrupa el catálogo de la vista de integraciones:
//   marketplace | tienda-online
//
// OJO: "Conectadas" también sale de este catálogo. Una plataforma que no está
// acá no se muestra aunque el comercio la tenga vinculada: no la ve ni la puede
// desvincular desde el portal (sus pedidos siguen entrando igual).
export const posibleIntegrations = [
    { name: "MercadoLibre", value: true, icon: "ml", expand: true, category: "marketplace" },
    { name: "Falabella", value: true, icon: "falabella", expand: true, category: "marketplace" },
    { name: 'Ripley', value: true, expand: true, icon: 'ripley', category: "marketplace" },
    { name: "WooCommerce", value: true, expand: true, icon: "woo", category: "tienda-online" },
    { name: "Shopify", value: true, icon: "shopify", category: "tienda-online" },
    { name: "Jumpseller", value: true, icon: "jumpseller", category: "tienda-online" },
    { name: "Prestashop", value: true, expand: true, icon: "prestashop", category: "tienda-online" },
    // El backend guarda la integración con integrationName "TiendaNube": este
    // `name` debe coincidir exacto o la tarjeta no salta de "Disponibles" a
    // "Conectadas" al terminar el OAuth.
    { name: "TiendaNube", value: true, icon: "tiendanube", category: "tienda-online" },
    // Idem TiendaNube: el backend guarda la integración con integrationName
    // "Wix" (TitleCase exacto). getLinkedIntegrations compara con === contra
    // este `name`; cualquier otro casing deja la tarjeta en "Disponibles" para
    // siempre, aunque la tienda esté conectada.
    { name: "Wix", value: true, icon: "wix", category: "tienda-online" },
    // Idem: el backend guarda integrationName "Paris" (TitleCase exacto).
    { name: "Paris", value: true, icon: "paris", category: "marketplace" },
  ];
